import { useQuery } from 'react-query';
import CheckmateApiClient from '../../services/apiClient';

const _apiClient = new CheckmateApiClient();

export const useQuadCaseManagersInZone = (zoneGuid: string, enabled: boolean = true) => {

    return useQuery({
        queryKey: ['get-quad-case-managers-in-zone'],
        queryFn: async () => {
            const response = await _apiClient.getQuadCaseManagersInZone(zoneGuid);

            if (response.httpResponse.status === 401) {
                window.location.reload();
            }

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve case managers.');
            } else if (response.errorMessage) {
                throw new Error(response.errorMessage);
            }

            return response.payload;
        },
        staleTime: 1 * 60 * 1000,
        enabled: enabled && !!zoneGuid
    });
};
